import { defineStore } from 'pinia';

export const useProductStore = defineStore('product', {
  state: () => ({
    lastOpenedTabId: '',
    tabs: [
      {
        id: 'included',
        title: 'What\'s Included',
      },
      {
        id: 'dimensions',
        title: 'Weight & Dimensions',
      },
      {
        id: 'specifications',
        title: 'Features & Specifications',
      },
      {
        id: 'description',
        title: 'Description',
      },
      {
        id: 'shipping',
        title: 'Shipping Box Dimensions',
      },
      {
        id: 'assembly',
        title: 'Assembly Information',
      },
      {
        id: 'reviews',
        title: 'Honest reviews',
      },
    ],
  }),
  actions: {
    openTab(tabId: string) {
      this.lastOpenedTabId = tabId;
    },
    resetLastOpenedTabId() {
      this.lastOpenedTabId = ''; // for sf-accordion "open" attribute watcher
    },
  },
});
